export default __webpack_public_path__ + "static/media/ZingProjectH.bac0e579.png";